import { init as initApm } from "@elastic/apm-rum";

const apm = initApm({
  serviceName: "web-frontend",
  serverUrl:
    "https://c185753f8f3d44c0add41f1b92383251.apm.us-central1.gcp.cloud.es.io:443",
  environment:
    process.env.NODE_ENV === "production" ? "production" : "development",
  serviceVersion: "1.0.0",
  distributedTracingOrigins: [process.env.REACT_APP_API_URL],
  propagateTracestate: true,
  breakdownMetrics: true,
  centralConfig: true,
  flushInterval: 5,
  disableInstrumentations: ["error"],
});

export default apm;
